// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'help/:pathMatch(.*)?',
        name: consts.routerNames.help.main,
        meta: {
            mainRouteName: consts.routerNames.help.main,
            hideMap: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/HelpPage.vue')
    },
];

export default routes;